import { TFunction } from 'i18next';
import z from 'zod';

export function useSchema({ t }: { t: TFunction<'translation', undefined> }) {
  const schema = z.object({
    telefon: z
      .string()
      .min(1, {
        message: t('domain.vertraege.kuendigenForm.fields.telefon.required'),
      })
      .regex(
        /^[^A-Za-z]*$/,
        t('domain.vertraege.kuendigenForm.fields.telefon.onlyNumbers'),
      ),
    beschreibung: z.string(),
  });
  return schema;
}
